module.exports = __webpack_public_path__ + "img/link01.a7e54093.png";